export function formatZARCurrency(amountString) {
  // Remove any non-numeric characters except the decimal point
  const numericAmount = parseFloat(amountString.replace(/[^0-9.]/g, ""));

  // Format the number with comma separators and two decimals
  const formattedNumber = numericAmount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // Prefix with "R" directly, no space
  return "R" + formattedNumber;
}
